export type VerseTextSelection = { localStart: number; localEnd: number; selectedText: string }
export type VerseGlyphMap = Array<{ start: number; end: number } | null>

/** Only mapped glyphs contribute. DOM text length is never a source offset. */
export function readVerseSelection(root: HTMLElement, literal: string, selection: Selection | null): VerseTextSelection | null {
  if (!selection || selection.rangeCount !== 1 || selection.isCollapsed) return null
  const range = selection.getRangeAt(0)
  if (!root.contains(range.startContainer) || !root.contains(range.endContainer)) return null
  let start = Infinity, end = -1
  for (const body of Array.from(root.querySelectorAll<HTMLElement>('[data-verse-glyph-map]'))) {
    const node = body.firstChild
    if (!node || node.nodeType !== Node.TEXT_NODE || body.childNodes.length !== 1) continue
    let map: VerseGlyphMap
    try { map = JSON.parse(body.dataset.verseGlyphMap!) } catch { return null }
    if (!Array.isArray(map)) return null
    if (map.length !== node.textContent?.length) return null // stale DOM: fail closed
    for (let i = 0; i < map.length; i++) {
      const span = map[i]
      if (!span) continue
      if (!Number.isInteger(span.start) || !Number.isInteger(span.end) || span.start < 0 || span.end !== span.start + 1 || span.end > literal.length) return null
      const glyph = document.createRange()
      glyph.setStart(node, i); glyph.setEnd(node, i + 1)
      if (range.compareBoundaryPoints(Range.END_TO_START, glyph) < 0 && range.compareBoundaryPoints(Range.START_TO_END, glyph) > 0) {
        start = Math.min(start, span.start); end = Math.max(end, span.end)
      }
    }
  }
  if (start < 0 || end > literal.length || end <= start || !Number.isFinite(start)) return null
  const selectedText = literal.slice(start, end)
  return selectedText.trim() ? { localStart: start, localEnd: end, selectedText } : null
}
